import { useListBoxSection } from '@react-aria/listbox'
import { useSeparator } from '@react-aria/separator'
import { Option } from './Option'
import Styles from '../ListBox.module.scss'
import { Text } from 'blaze-ui/Text/Text'

export const Section = ({ section, state, optionClassName }: any) => {
  let { itemProps, headingProps, groupProps } = useListBoxSection({
    heading: section.rendered,
    'aria-label': section['aria-label'],
  })

  let { separatorProps } = useSeparator({
    elementType: 'div',
  })

  return (
    <>
      {section.key !== state.collection.getFirstKey() && <div {...separatorProps} className={Styles.separator} />}
      <div {...itemProps}>
        {section.rendered && (
          <div className={Styles.sectionHeading}>
            <Text variant="label" {...headingProps}>
              {section.rendered}
            </Text>
          </div>
        )}
        <div {...groupProps} className={Styles.root}>
          {[...section.childNodes].map((item) => (
            <Option key={item.key} item={item} state={state} className={optionClassName} />
          ))}
        </div>
      </div>
    </>
  )
}
